import React from "react";
import {CardContainer} from "./card.styles.js";
function Card({
  children,
  raised = false
}) {
  return /* @__PURE__ */ React.createElement(CardContainer, {
    raised
  }, children);
}
export default /* @__PURE__ */ React.memo(Card);
